import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
export interface MutateParams {
  section: string;
  message: string;
  profileId: string;
  type: string[];
}

export interface Response {
  data: {
    success: boolean;
  };
}

export const useFeedback = () => {
  return useMutation<Response, Error, MutateParams>({
    mutationFn: async (params: MutateParams) =>
      axios.post(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/feedback`, {
        ...params,
      }),
    onError: (error) => {
      console.error(error);
    },
  });
};
